// Event Tracking Helper
// Use this to track button clicks like Reserve Now, WhatsApp, etc.

export const trackEvent = async (
    eventType: 'reserve_click' | 'whatsapp_click' | 'whatsapp_floating' | 'call_click' | 'email_click',
    options?: {
        packageId?: number;
        packageTitle?: string;
    }
) => {
    try {
        await fetch('/api/track/event/', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                event_type: eventType,
                page_path: window.location.pathname,
                package_id: options?.packageId,
                package_title: options?.packageTitle,
            }),
        });
    } catch (error) {
        // Silently fail - don't break the app for analytics
        console.debug('Event tracking failed:', error);
    }
};

export default trackEvent;
